// 该类存放项目中七牛云相关接口
import axios from 'axios';
import localhost from './localhost.js';
class qiniu {
  getToken (fileName) { // 取token
    var params = new URLSearchParams();
    params.append('transkey', fileName + '.mp4');
    params.append('photokey', fileName + '.jpg');
    params.append('getTokenType', 'xfx');
    return new Promise(function (resolve, reject) {
      axios.post(localhost.rooturl + '/studygame/qiniu/pktoken', params)
        .then(function (res) {
          resolve(res.data.uptoken)
        })
        .catch(function (err) {
          reject();
        });
    })
  };
}

export default new qiniu();



// WEBPACK FOOTER //
// ./src/utils/qiniu.js